export default "/_next/static/images/pot-bc1272fa32b60076c379f6754edc3177.png";